import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

let sentryInitialized = false;

export function initializeSentry() {
  const dsn = import.meta.env.VITE_PUBLIC_SENTRY_DSN;
  if (sentryInitialized || !dsn) {
    return;
  }

  Sentry.init({
    dsn,
    tunnel: import.meta.env.VITE_PUBLIC_SENTRY_TUNNEL,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/api.promptfoo\.app/],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  sentryInitialized = true;
}
